import { render } from "./ResumeTab.vue?vue&type=template&id=10fb07d0&scoped=true"
import script from "./ResumeTab.vue?vue&type=script&lang=js"
export * from "./ResumeTab.vue?vue&type=script&lang=js"

import "./ResumeTab.vue?vue&type=style&index=0&id=10fb07d0&scoped=true&lang=css"
import "./ResumeTab.vue?vue&type=style&index=1&id=10fb07d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fb07d0"]])

export default __exports__